import { render, staticRenderFns } from "./libraryFactView.vue?vue&type=template&id=628d3c90"
import script from "./libraryFactView.vue?vue&type=script&lang=js"
export * from "./libraryFactView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports